import { useCallback } from "react";
import { axiosChallenges } from "./axios";

export interface IAddFavoriteOffer {
  offer: string;
  challenges: string[];
}

export const useAddFavoriteOffer = () => {
  const [state, execute, cancel] = axiosChallenges<void, IAddFavoriteOffer, unknown>(
    {
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: IAddFavoriteOffer) => {
      return execute({
        url: "/stars",
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
